import { ExportGridRef } from '@ihsm/ui-shared';
import React, { useEffect, useState } from 'react';
import { useGetMappingsQuery } from 'services/newApi/positionsApi';
import { FullViewLoading } from 'shared/components/FullViewLoading';
import { PortfoliosSceneGrid } from 'shared/components/ReactDataGrid/PortfoliosSceneGrid/components/PortfoliosSceneGrid';
import { mappingTableColumns } from 'shared/components/ReactDataGrid/PortfoliosSceneGrid/utils';
import { formatDateForURL } from 'shared/utils';
import '../PortfoliosFundTable/PortfoliosFundTable.scss';

export const PortfoliosMappingTable: React.FC<{
  gridExportRef: React.RefObject<ExportGridRef>;
}> = ({ gridExportRef }): JSX.Element => {
  const [showLoading, setShowLoading] = useState<boolean>(true);

  const {
    data: mappingsList = [],
    isError,
    isLoading,
  } = useGetMappingsQuery({ selectedContext: 'DemoPortfolio' });

  useEffect(() => {
    if (!isLoading || isError) setShowLoading(false);
  }, [isError, isLoading, mappingsList, setShowLoading]);

  return (
    <div className="bottom-section-wrapper all">
      <FullViewLoading forceLoadingScreen={showLoading}>
        <PortfoliosSceneGrid
          data={mappingsList}
          gridExportRef={gridExportRef}
          exportFileName={`Portfolios_Mappings_${formatDateForURL(new Date())}`}
          columns={mappingTableColumns}
        />
      </FullViewLoading>
    </div>
  );
};
